/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pertinent_InfoInputs */

const en_pertinent_info = /** @type {(inputs: Pertinent_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertinent Info`)
};

const es_pertinent_info = /** @type {(inputs: Pertinent_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion pertinente`)
};

/**
* | output |
* | --- |
* | "Pertinent Info" |
*
* @param {Pertinent_InfoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pertinent_info = /** @type {((inputs?: Pertinent_InfoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pertinent_InfoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pertinent_info(inputs)
	return es_pertinent_info(inputs)
});